import angular from "angular"

const templateUrl = require("ngtemplate-loader!html-loader!./admin.component.html")

AdminComponent.$inject = ["UserService", "GroupService", "UserFlagService"]
function AdminComponent(UserService, GroupService, UserFlagService) {
  var self = this

  self.showActions = false

  self.refreshRolesCallback = function() {
    if (self.refreshUsuarios === undefined) {
      self.refreshUsuarios = 0
    } else {
      self.refreshUsuarios += 1
    }
  }

  self.modelName = "usuarios"

  self._columns = [
    {
      key: "username",
      value: "username"
    },
    {
      key: "first_name",
      value: "nombre"
    },
    {
      key: "last_name",
      value: "apellido"
    },
    {
      key: "rol",
      value: "tipo de usuario"
    },
    {
      key: "email",
      value: "email"
    }
  ]

  self.menuOptions = [
    {
      name: "Editar",
      callback: "editRow",
      args: "editar"
    },
    {
      name: "Desactivar",
      callback: "deleteRow"
    }
  ]

  self.crudMenu = [
    {
      action: "crear",
      icon_name: "add",
      callback: "create"
    },
    {
      action: "eliminar",
      icon_name: "delete",
      callback: "delete"
    }
  ]

  self.onCreate = function(post_data) {
    return UserService.save(post_data).$promise
  }

  self.onEdit = function(user) {
    return UserService.update({ user: user.id }, user).$promise
  }

  self.onDelete = function(models) {
    return UserService.remove({ "users[]": models }).$promise
  }

  self._getModels = function() {
    return UserService.get().$promise.then(function(response) {
      return response.results
    })
  }

  //roles

  self.modelNameRoles = "roles"

  self._columnsRoles = [
    {
      key: "name",
      value: "nombre"
    }
  ]

  self.menuOptionsRoles = [
    {
      name: "Editar",
      callback: "editRow",
      args: "editar"
    },
    {
      name: "Eliminar",
      callback: "deleteRow"
    }
  ]

  self.crudMenuRoles = [
    {
      action: "crear",
      icon_name: "add",
      callback: "create"
    },
    {
      action: "eliminar",
      icon_name: "delete",
      callback: "delete"
    }
  ]

  self.onCreateRoles = function(post_data) {
    console.log(post_data)
    return GroupService.save(post_data).$promise
  }

  self.onEditRoles = function(rol) {
    return GroupService.update({ id: rol.id }, rol).$promise
  }

  self.onDeleteRoles = function(models) {
    return GroupService.remove({ "roles[]": models }).$promise
  }

  self._getModelsRoles = function() {
    return GroupService.get().$promise.then(function(response) {
      return response.results
    })
  }

  self.$onInit = function() {
    UserFlagService.getFlagValue(function(canEditForm) {
      self.showActions = !canEditForm
    })
  }
}

angular.module("appModule").component("admin", {
  templateUrl: templateUrl,
  bindings: {},
  controller: AdminComponent
})
